import { render, staticRenderFns } from "./FollowUs.vue?vue&type=template&id=9ea9a75a&scoped=true"
import script from "./FollowUs.vue?vue&type=script&lang=js"
export * from "./FollowUs.vue?vue&type=script&lang=js"
import style0 from "./FollowUs.vue?vue&type=style&index=0&id=9ea9a75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea9a75a",
  null
  
)

/* custom blocks */
import block0 from "./FollowUs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports